import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";

const PopularCard = ({ children, description, title }) => (
  <div
    className="tw-relative tw-overflow-hidden tw-h-[490px] tw-rounded-[16px] tw-w-[626px] before:tw-absolute before:tw-inset-0 before:tw-content-[''] before:tw-bg-[linear-gradient(to_bottom,rgba(255,255,255,0.7)_0%,rgba(255,255,255,0.7)_80%,white)]"
    style={{
      background: "url(/images/bg-addon-popular.jpg) center center/cover no-repeat",
    }}
  >
    <div className="tw-relative tw-h-full tw-rounded-[16px] tw-p-[32px] tw-flex tw-flex-col tw-gap-[16px]">
      <div className="tw-flex tw-flex-col tw-gap-[8px]">
        <Typography variant="headline3" className="!tw-text-24d !tw-font-bold">
          {title}
        </Typography>
        <Typography className="tw-max-w-[400px]">{description}</Typography>
      </div>
      <div className="tw-flex-1 tw-relative">{children}</div>
    </div>
  </div>
);

PopularCard.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

PopularCard.defaultProps = {
  children: null,
};

export default PopularCard;
